module.exports = __webpack_public_path__ + "img/dugout-lounge-tables-03.20bd9ff9.jpeg";